import { NotificationMessageTypeEnum } from './notification-message-type.enum';

export class NotificationMessage {
    type: NotificationMessageTypeEnum = NotificationMessageTypeEnum.Info;
    message: string;
  }
  